export function getDescriptions() {
	return [
		{
			url: '/tests/rule-definition',
			getModuleImport: () => import('areas/tests/ruleDefinition'),
			react: true,
		},
	];
}
